import React, { useState } from 'react';
import './Hero.css';
import technopark from "../images/technopark.jpg";
import homepage1 from "../images/homepage3.png";
import LeadPopup from './LeadPopup';

function Hero() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <section className="hero-section-premium">
      <div className="hero-container-premium">
        <div className="hero-content-premium animate-fadeInUp">
          <div className="status-badge-premium-v2">
            <span className="dot-premium"></span>
            AUTOMATE • SECURE • ACCELERATE
          </div>

          <h1 className="hero-headline-premium">
            The All-in-One <span className="gradient-text-premium">Core Banking SaaS</span> Platform.
          </h1>

          <p className="hero-subtext-premium">
            Unifying lending, deposits, and intelligence into a single, secure ecosystem. Built for modern financial institutions that demand speed and precision.
          </p>

          <div className="hero-ctas-premium">
            <button className="btn-get-started-premium" onClick={() => setIsPopupOpen(true)}>
              Get Started
            </button>
            {/* <button className="btn-primary-premium" onClick={() => setIsPopupOpen(true)}>
              Request a Demo
            </button>
            <button className="btn-secondary-premium">Talk to Sales</button> */}
          </div>
        </div>

        <div className="hero-image-column animate-fadeInRight">
          <img src={homepage1} alt="IGNOSI Core Banking" className="hero-main-image" />
        </div>
      </div>

      <LeadPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />

      <div className="trust-indicators-premium">
        <div className="trust-grid-premium">
          <div className="trust-item-premium">
            <span className="trust-number-premium">1500+</span>
            <span className="trust-label-premium">Financial Institutions Trust Us</span>
          </div>
          <div className="trust-item-premium">
            <span className="trust-number-premium">120 Cr+</span>
            <span className="trust-label-premium">High-volume daily Cash & Bank Transactions Managing</span>
          </div>
          <div className="trust-item-premium">
            <span className="trust-label-premium">Audit-ready | Compliance-first</span>
            <div className="badge-group-premium">
              <span className="mini-badge-premium">ISO 27001</span>
              <span className="mini-badge-premium">PCI DSS</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
